/**
 * Get registered login
 * @param {object} params
 * @param {string} params.username
 * @param {string} params.password
 */
import { AUTH_URL } from '@core/constants';

export async function authLogin({ username, password }) {
  try {
    const url = AUTH_URL;
    //const url = "http://localhost:8002/api-token-auth/"

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username: username.toLowerCase(), password }),
    });
    const data = await response.json();
    if (data.token) {
      return { type: 'success', data };
    } else {
      return { type: 'error', message: 'Correo o contraseña incorrectas' };
    }
  } catch (error) {
    console.error('Error fetching login', error);
    return { type: 'error', message: 'Ocurrió un error' };
  }
}

/**
 * Remove session data from local storage
 */
export async function authLogout() {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('has_active_rms');
  localStorage.removeItem('can_create_case');
  localStorage.removeItem('app_version');
  localStorage.removeItem('studyViewerZoomMode');
  clearImagingStudyFilters();
  return true;
}

export async function AuthCheck() {
  const token = localStorage.getItem('token');
  if (token) {
    // console.log(true)
    return true;
  } else {
    return false;
  }
}

/**
 * Read isAdmin flag from localStorage.
 * Returns: true | false | null (if not set) | raw value if non-boolean stringified
 */
export function getIsAdmin() {
  const v = localStorage.getItem('isAdmin');
  if (v === null) return null;
  if (v === 'true') return true;
  if (v === 'false') return false;
  try {
    return JSON.parse(v);
  } catch (e) {
    return v;
  }
}

/**
 * Clear ImagingStudyList filters and state from sessionStorage on login
 */
export function clearImagingStudyFilters() {
  sessionStorage.removeItem('imagingStudiesReturnSelectedDate');
  sessionStorage.removeItem('imagingStudiesReturnStatusFilter');
  sessionStorage.removeItem('imagingStudiesReturnFilters');
  sessionStorage.removeItem('imagingStudiesReturnPageSize');
  sessionStorage.removeItem('imagingStudiesReturnLazyState');
  sessionStorage.removeItem('imagingStudiesCardStatusFilter');
  sessionStorage.removeItem('imagingStudiesActiveFilter');
}
